import {useState, useEffect} from 'react';
import '../../../src/styles/healthInfo.css';
import Button from 'react-bootstrap/Button';
import SelectedServer from './SelectedServer';
import CustomTooltipAck from '../tooltips/CustomTooltipAck';
import NinjaDetails from './ninja/NinjaDetails';
import DeviceInfoIcon from './ninja/DeviceInfoIcon';
import { API } from '../../api';
// import Server from './Server';

// Import generic components
import Table from '../../generic_components/Table/Table';
import Modal from '../../generic_components/Modal/Modal';
import { useToast } from '../../generic_components/Toast/Toast';

const UnAckAlerts = ({ unAckAlerts, userBusinessRole }) => {

  const [selectedServerName, setSelectedServerName] = useState('');  
  const [show, setShow] = useState(false);
  const [showNinjaModal, setShowNinjaModal] = useState(false);
  const [selectedServer, setSelectedServer] = useState(null);
  // const [ack, setAck] = useState(selectedServer?.serverAckData?.serverAckStatus);
  const [ack, setAck] = useState(false);
  useEffect(() => {
    setAck(selectedServer?.serverAckData?.serverAckStatus || false);
  }, [selectedServer]);

  const [showAckWarning, setShowAckWarning] = useState(false);
  
  
  const handleAckWarningClose = () => setShowAckWarning(false);
  const handleAckWarningShow = () => setShowAckWarning(true);
  const handleNinjaModalClose = () => setShowNinjaModal(false);
  const handleNinjaModalShow = (server) => {
    setShowNinjaModal(true);
    setSelectedServer(server);
  }

  const user = localStorage.getItem('email');
  
  const toast = useToast();
  
  const handleClose = () => {
    setShow(false);
    setSelectedServerName('');
  }

  const handleShow = (server, serverName) => {
    setSelectedServerName(serverName);
    setSelectedServer(server);
    setShow(true);
  }

    // Utility to format date as MM/DD/YYYY HH:MM:SS
  const getFormattedTime = () => {
    const now = new Date();
    return now.toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }) + 
          ' ' + 
          now.toLocaleTimeString('en-US', { hour12: false });
  };

  const handleACK = async (serverName) => {
    if (ack) {
      alert("This fault has already been acknowledged.");
      return;
    }
  
    try {
      const hwid = selectedServer.hwid || 'N/A'; // Fallback to 'N/A' if hwid is not available
      const ackData = { serverName, user, hwid };
  
      const response = await API.post('/ack', ackData); // 👈 Using your API instance
  
      handleAckWarningClose(); // Close the modal after acknowledgment
  
      if (response.data?.msg === 200) {
        const successMsg = "Fault successfully acknowledged.";     
          toast.success(successMsg, {
            hideProgressBar: true,
            autoClose: 9000
          })
  
        // Dynamically update server data
        selectedServer.serverAckData.ackBy = user;
        selectedServer.serverAckData.ackTime = getFormattedTime();
        selectedServer.serverAckData.ackMode = "portal";
  
        setAck(true); // React state triggers re-render
      } else {
        alert("Internal server error. Please try again later.");
      }
    } catch (error) {
      console.error(error);
      alert("Internal server error. Please try again later.");
    }
  };


  const utcStrToLocal = (utcTimestamp) => {
    // Create a Date object using the UTC timestamp
    const utcDate = new Date(utcTimestamp);

    // Get the local time components
    const localYear = utcDate.getFullYear();
    const localMonth = utcDate.getMonth() + 1; // Months are zero-based
    const localDay = utcDate.getDate();
    const localHours = utcDate.getHours();
    const localMinutes = utcDate.getMinutes();
    const localSeconds = utcDate.getSeconds();
    // Create a new Date object with the local time components
    const localDate = new Date(localYear, localMonth - 1, localDay, localHours, localMinutes, localSeconds);
    // Format the local time as needed
    const formattedLocalTime = localDate.toLocaleString();
    return formattedLocalTime
  }

  // calculate total days since the give date time given have passed
  const daysSince = (targetDateStr) => {
    //const targetDate = parseCustomDateFormat(targetDateStr);    
    // Get the current local date and time
    let currentDate = new Date().toISOString();
    
    // Parse the date strings into Date objects
    currentDate = new Date(currentDate);
    let targetDate = new Date(targetDateStr);    

    // Calculate the time difference in milliseconds
    const timeDifference = currentDate - targetDate;     
   
    // Convert milliseconds to days
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);    
    return Math.floor(daysDifference);
  }

  function convertUtcToLocal(utcTime) {
    // Create a Date object from the UTC time string
    const date = new Date(utcTime);

    // Format the local time using toLocaleString
    return date.toLocaleString();
  }



  const unAckAlerts_columns = [
    { key: 'site', label: 'Site Name' },
    { key: 'siName', label: 'SI Name' },
    { key: 'serverName', label: 'Server Name' },
    { key: 'serverStatus', label: 'Server Status' },
    { key: 'activityTime', label: 'Activity Time' },
    { key: 'serverOfflineSince', label: 'Server Offline Since' },
    { key: 'camerasTotalOffline', label: 'Cameras - Total / Offline' },
    { key: 'cameraDetails', label: 'Camera Details' },
  ];

  // let serverOfflineSince = selectedServer?.serverOfflineSince;
  // // server offline activity
  // if (selectedServer?.serverOfflineSince !== 'N/A') {
  //     serverOfflineSince = utcStrToLocal(selectedServer?.serverOfflineSince);
  // }
  // else {
  //   serverOfflineSince = '-'
  // }

  const unAckAlerts_data = unAckAlerts.map((server, index) => {
    let serverOfflineSince = server.serverOfflineSince;
    // server offline activity
    let offlineDays = 0;
    if (server.serverOfflineSince !== 'N/A') {
        serverOfflineSince = utcStrToLocal(server.serverOfflineSince);
        offlineDays = daysSince(server.serverOfflineSince);
    }
    else {
      serverOfflineSince = '-'
    }

    // server online activity
    let onlineDays = 1;
    if (server.serverStatus === 'Online') {
      onlineDays = server.serverOnlineDays;
    }

    // server activity time
    let activityDays = 0;
    if (server.serverStatus === 'Online') {
      activityDays = onlineDays;
    } else {
      activityDays = offlineDays;
    }


    let deviceColor = '#C82333';
    if (server.devicesOffline === 0) {
      deviceColor = '#22BE63';
    }

    let serverColor = '#C82333';
    if (server.serverStatus === 'Online') {
      serverColor = '#22BE63';
    }

    let activityColor = '#C82333';
    if (server.serverStatus === 'Online') {
      activityColor = '#22BE63';
    }

    let isAlert = true;
    let isUnAck= true;

    return (
    {
      site: (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>{server.site}</span>
          <DeviceInfoIcon 
            onClick={() => handleNinjaModalShow(server)}
            disabled={!server.ninjaDetail?.ninjaData}
            server={server}
          />
        </div>
      ),
      siName: server.si,
      serverName: server.serverName,
      serverStatus: (
        <span style={{ color: serverColor, fontWeight: '600' }}>
          {server.serverStatus}
        </span>
      ),
      activityTime: (
        <div style={{fontWeight: '600'}}>
          { server.serverStatus === 'Online' ? 
            <svg  style={{ color: '#22BE63' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up-right-circle" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 10.803a.5.5 0 1 1-.708-.707L9.243 6H6.475a.5.5 0 1 1 0-1h3.975a.5.5 0 0 1 .5.5v3.975a.5.5 0 1 1-1 0V6.707l-4.096 4.096z"/>
            </svg> :
            <svg style={{ color: '#C82333' }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down-right-circle" viewBox="0 0 16 16">
               <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.854 5.146a.5.5 0 1 0-.708.708L9.243 9.95H6.475a.5.5 0 1 0 0 1h3.975a.5.5 0 0 0 .5-.5V6.475a.5.5 0 1 0-1 0v2.768L5.854 5.146z"/>
          </svg>
          }
          <span style={{ color: activityColor, marginLeft: '.2rem' }}>{activityDays}d</span>
      </div>
      ),
      serverOfflineSince: serverOfflineSince,
      camerasTotalOffline: (
        <span style={{ width:'3.5em' }}>
          {server.totalDevices} / <span style={{ color: deviceColor, fontWeight: '600'}}>{server.devicesOffline}</span>
        </span>
      ),
      cameraDetails: (
        <div style={{ display: 'flex' , alignItems:'center', justifyContent:'space-between'}}>
          
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <Button className='alert-table-details-btn' disabled={!server.totalDevices} variant='dark'  onClick={() => handleShow(server, server.serverName)}>
              Details
            </Button>
            {!isUnAck ? (
            isAlert ? (               
              <>                  
              { ack ? 
                <CustomTooltipAck text={`Acknowledged by ${server.serverAckData.ackBy} on ${convertUtcToLocal(server.serverAckData.ackTime)} via ${server.serverAckData.ackMode}`}>
                  <input type="checkbox"  checked={true} style={{ marginLeft: '6em' }} />
                </CustomTooltipAck>
                : 
                <div id='unack-chkbox-container'>
                <input type="checkbox" className="custom-checkbox" checked={ack} onChange={handleAckWarningShow} />
                  <span style={{ marginLeft: '.4em' }}>Acknowledge</span>
                </div>
              }
            </>
            ) : null
            ): null}
          </div>
        </div> 
      )
    }
  )

})



  return (
    <div className='table-container-unackalerts'>        
      <Table 
      columns = {unAckAlerts_columns}
      data = {unAckAlerts_data}
      />

      {/* Ninja Details Modal */}
      <Modal size='xl' show={showNinjaModal} onHide={handleNinjaModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <span style={{ color:'white', fontSize: 'medium' }}>
              🖥️ System Details - {selectedServer?.serverName}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NinjaDetails ninjaData={selectedServer?.ninjaDetail?.ninjaData} />
        </Modal.Body>
      </Modal>

      {/* modal to view device details */}
      <Modal size='lg' show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Cameras</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <SelectedServer  serverOfflineSince={selectedServer?.serverOfflineSince !== 'N/A' ? utcStrToLocal(selectedServer?.serverOfflineSince) : '-'} serverStatus={selectedServer?.serverStatus}  serverName={selectedServerName} site={selectedServer?.site} userBusinessRole={userBusinessRole}/>
        </Modal.Body>
      </Modal>

          {/* modal to view ack warning */}

      <Modal show={showAckWarning} onHide={handleAckWarningClose}>
        <Modal.Header closeButton >
          <Modal.Title>Fault Acknowledgement</Modal.Title>
        </Modal.Header>
        <Modal.Body>         
            <div>Do you want to acknowledge the fault for <span style={{ color: '#22BE63' }}>{selectedServer?.serverName}</span> ?</div>
            <div> Click "Acknowledge" to confirm or "Cancel" to dismiss.</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1em' }}>              
              <Button size='small' variant='danger' onClick={() => handleACK(selectedServer?.serverName)}>Acknowledge</Button>
              <Button size='small' variant='secondary' onClick={handleAckWarningClose}>Cancel</Button>
            </div>       
        </Modal.Body>
      </Modal>
  </div>
  )
}

export default UnAckAlerts